import type { Faq, FaqCategory } from "@app-types/index";

export const faqCategories: FaqCategory[] = [
  "Cotización",
  "Pagos",
  "Siniestros",
  "Productos",
];

export const faqs: Faq[] = [
  // Cotización
  {
    slug: "tiempo-cotizacion",
    category: "Cotización",
    question: "¿En cuánto tiempo me cotizan un seguro?",
    answer:
      "La cotización inicial se entrega en menos de 24 horas hábiles. Para autos y hogares estándar, generalmente el mismo día.",
    related: { label: "Pedir cotización", to: "/contacto" },
  },
  {
    slug: "varias-companias",
    category: "Cotización",
    question: "¿Trabajan con varias compañías aseguradoras?",
    answer:
      "Sí, somos brokers independientes. Comparamos coberturas y precios entre las principales aseguradoras del país (Sancor, La Caja, Allianz, Federación Patronal y más) para que elijas la mejor opción según tu perfil.",
    related: { label: "Ver aseguradoras", to: "/nosotros" },
  },
  {
    slug: "documentacion",
    category: "Cotización",
    question: "¿Qué documentación necesito para contratar?",
    answer:
      "Para personas: DNI y datos del bien a asegurar (cédula verde del auto, escritura o contrato del inmueble). Para empresas: CUIT, estatuto y datos del responsable. Te guiamos paso a paso, no hace falta que traigas todo de entrada.",
  },
  {
    slug: "cotizacion-sin-compromiso",
    category: "Cotización",
    question: "¿La cotización tiene costo o compromiso?",
    answer:
      "Es totalmente gratuita y sin obligación de contratar. Nos pagan las compañías aseguradoras si decidís avanzar — vos no abonás un centavo por la asesoría.",
  },

  // Pagos
  {
    slug: "pagos-mensuales",
    category: "Pagos",
    question: "¿Puedo pagar mensualmente?",
    answer:
      "Sí. Ofrecemos planes mensuales, trimestrales, semestrales y anuales según el producto. Aceptamos transferencia/CBU y efectivo según la aseguradora.",
  },
  {
    slug: "ajustes-precio",
    category: "Pagos",
    question: "¿Por qué se ajusta el precio de la póliza?",
    answer:
      "Las pólizas se ajustan automáticamente por inflación o cambios en el valor del bien asegurado (por ejemplo, el valor del auto en el mercado). Te avisamos antes de cada renovación y podés revisar la cobertura conmigo.",
  },
  {
    slug: "cancelar-poliza",
    category: "Pagos",
    question: "¿Puedo cancelar la póliza antes del vencimiento?",
    answer:
      "Sí. Podés cancelarla en cualquier momento. Si pagaste por adelantado, la aseguradora reintegra la parte proporcional no consumida según las condiciones de la póliza.",
  },

  // Siniestros
  {
    slug: "atencion-siniestro",
    category: "Siniestros",
    question: "¿Cómo es la atención en caso de siniestro?",
    answer:
      "Te asignamos un productor que te acompaña durante todo el proceso: denuncia, peritaje y cobro de la indemnización. Tenemos WhatsApp directo para emergencias 24/7.",
  },
  {
    slug: "plazo-siniestro",
    category: "Siniestros",
    question: "¿En cuánto tiempo se cobra un siniestro?",
    answer:
      "Depende del tipo de siniestro y la aseguradora. En autos, los siniestros sin terceros se liquidan en 7 a 15 días hábiles. Con terceros o reclamos complejos puede demorar 30 a 60 días. Te mantenemos al tanto del estado en cada etapa.",
  },
  {
    slug: "denunciar-siniestro",
    category: "Siniestros",
    question: "¿Cómo denuncio un siniestro?",
    answer:
      "Contactanos por WhatsApp o teléfono apenas ocurra. Te indicamos los pasos: tomar fotos, hacer la denuncia policial si corresponde, y juntar la documentación. Nosotros nos encargamos del trámite con la aseguradora.",
    related: { label: "Contactar urgente", to: "/contacto" },
  },

  // Productos
  {
    slug: "productos-disponibles",
    category: "Productos",
    question: "¿Qué tipos de seguros manejan?",
    answer:
      "Trabajamos toda la línea: automotor (autos, motos, comerciales), hogar, vida individual y colectiva, comercio, ART, accidentes personales, caución, transporte y embarcaciones. Si necesitás algo puntual, consultanos.",
    related: { label: "Ver todos los productos", to: "/productos" },
  },
  {
    slug: "auto-0km",
    category: "Productos",
    question: "¿Cubren autos 0km y de alta gama?",
    answer:
      "Sí, trabajamos coberturas todo riesgo para vehículos 0km y autos de alta gama, incluyendo importados. Las compañías evalúan cada caso y ofrecemos varias opciones según presupuesto.",
  },
  {
    slug: "pyme-comercio",
    category: "Productos",
    question: "Tengo una pyme, ¿qué seguros necesito?",
    answer:
      "Lo básico es: integral de comercio (stock, robo, incendio, RC), ART para empleados y, si tenés vehículos, automotor flota. Te armamos un plan a medida según facturación, rubro y riesgo del lugar.",
  },
];

export function faqsByCategory() {
  return faqs.reduce<Record<string, Faq[]>>((acc, faq) => {
    (acc[faq.category] ??= []).push(faq);
    return acc;
  }, {});
}
